// Símbolo da marca "iexame" — extraído de components/Logo.jsx (era inline lá,
// hardcoded). `color`/`accent` são passados pelo chamador (Logo.jsx), que por
// sua vez recebe var(--text)/var(--brand-primary) ou overrides explícitos
// (ex.: branco quando renderizado sobre o hero escuro).
export default function BrandSymbol({ size = 28, color, accent }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" style={{ display: 'block' }}>
      <path d="M20 3 C 20 3, 14 11, 14 15 A 6 6 0 1 0 26 15 C 26 11, 20 3, 20 3 Z" fill={accent} />
      <rect x="15" y="25" width="10" height="13" rx="3" fill={color} />
      <rect x="15" y="33" width="10" height="5" rx="0" fill={color} opacity="0.55" />
    </svg>
  );
}
